import { memo } from 'react'

import { useModalManager } from '@wwt/core/modals'

import { Toaster } from '@/shared/ui/Toaster'

interface AppToasterProps {
	children?: React.ReactNode
}

export const AppToaster = memo(({ children }: AppToasterProps) => {
	const isModalsExists = useModalManager(state => state.modals.length > 0)
	return (
		<Toaster activeLayers={isModalsExists ? ['modals'] : []}>
			{children}
		</Toaster>
	)
})
AppToaster.displayName = 'AppToaster'
